import { Component } from '@angular/core';
import { ConsentService } from 'src/app/core/consent.service';
import { LanguageService } from 'src/app/core/language.service';

/**
 * GDPR-style cookie consent banner shown until the visitor accepts or rejects.
 * The choice is persisted by ConsentService; analytics should gate on it.
 */
@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.css']
})
export class CookieConsentComponent {
  /** Hides the banner once a choice has been stored. */
  visible = !this.consent.decided;

  constructor(public consent: ConsentService, public lang: LanguageService) {}

  accept(): void { this.consent.accept(); this.visible = false; }
  reject(): void { this.consent.reject(); this.visible = false; }
}
